module.exports = __webpack_public_path__ + "nmf_rent_icon.svg";